import { EventAttendanceModeType, EventJsonLdData, EventStatusType } from './jsonLdTypes'

/**
 * Generates JSON-LD structured data for event pages
 *
 * @param data Object containing event details
 * @returns JSON-LD object for schema.org Event type
 */
export const generateEventJsonLd = (data: EventJsonLdData) => {
  // Base JSON-LD object with required properties
  const jsonLd: Record<string, any> = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: data.name,
    startDate: data.startDate,
    eventAttendanceMode: data.eventAttendanceMode || EventAttendanceModeType.Offline,
    eventStatus: EventStatusType.Scheduled,
    organizer: {
      '@type': 'Organization',
      name: 'Careum',
      url: 'https://careum.ch',
    },
  }

  // Add optional properties only if they exist
  if (data.endDate) {
    jsonLd.endDate = data.endDate
  }

  if (data.description) {
    jsonLd.description = data.description
  }

  if (data.image) {
    jsonLd.image = [data.image]
  }

  // Add location if provided
  if (data.location?.name) {
    jsonLd.location = {
      '@type': 'Place',
      name: data.location.name,
    }

    // Add address if available
    if (data.location.address) {
      const address = data.location.address
      const postalAddress: Record<string, string> = {
        '@type': 'PostalAddress',
      }

      if (address.streetAddress) postalAddress.streetAddress = address.streetAddress
      if (address.addressLocality) postalAddress.addressLocality = address.addressLocality
      if (address.postalCode) postalAddress.postalCode = address.postalCode
      if (address.addressRegion) postalAddress.addressRegion = address.addressRegion
      if (address.addressCountry) postalAddress.addressCountry = address.addressCountry

      // Only add address if it has at least one property
      if (Object.keys(postalAddress).length > 1) {
        jsonLd.location.address = postalAddress
      }
    }

    if (data.offers) {
      jsonLd.offers = {
        '@type': 'Offer',
        price: data.offers.price,
        priceCurrency: data.offers.priceCurrency || 'CHF',
      }

      if (data.isAccessibleForFree) {
        jsonLd.offers.price = '0'
        jsonLd.isAccessibleForFree = true
      }
    }
  }

  return jsonLd
}
